import { render, staticRenderFns } from "./TraderNotification.vue?vue&type=template&id=4d51dcbc&"
import script from "./TraderNotification.vue?vue&type=script&lang=js&"
export * from "./TraderNotification.vue?vue&type=script&lang=js&"
import style0 from "./TraderNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports